<template>
  <div class="scrollable-container">
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MainContainer'
  };
</script>

<style scoped>
    .scrollable-container {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        width: 100%;
    }
    .container {
        height: 100%;
        margin: 0 1em;
    }
</style>
